module.exports = __webpack_public_path__ + "static/scale-model-of-indianapolis-zoo-in-indianapolis-indiana-50673a82789643d150586d22fbac1a62.png";